// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3xh2l","title":"Images90_title__1T5kU","images":"Images90_images__2ONax"};